import { state } from './state.js';
import _ from 'lodash';

export function escapeHtml(value = '') {
	return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export function removeAllChildNodes(parent) {
	if (typeof parent === 'undefined' || parent === null) {
		return;
	}
	while (parent.firstChild) {
		parent.removeChild(parent.firstChild);
	}
}

export function scrollStartStopHandler(element, onStart, onStop) {
	let handleOnStart = _.debounce(function () {
		state.isScrolling = true;
		onStart && onStart();
	}, 300, {'leading': true, 'trailing': false});

	let handleOnStop = _.debounce(function () {
		state.isScrolling = false;
		onStop && onStop();
	}, 300);

	element.addEventListener('scroll', handleOnStart);
	element.addEventListener('scroll', handleOnStop);

	function destroy() {
		element.removeEventListener('scroll', handleOnStart);
		element.removeEventListener('scroll', handleOnStop);
		state.isScrolling = false;
	}

	return {
		destroy: destroy,
	};
}

export function reportWindowSize() {
	state.vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
}
